import {gsap} from "./vendor.js";

let initialized = false;
let container, logo, bodyStyle;

function init() {
    if (initialized) {
        return;
    }

    container = document.querySelector(".js-loader");
    logo = container?.querySelector("mtl-logo");
    bodyStyle = getComputedStyle(document.body);
}

function reset() {
    return () => {
        container.removeAttribute("style");
        logo.removeAttribute("style");
    };
}

function setBlackBackground() {
    return () => {
        container.style.backgroundColor = bodyStyle.getPropertyValue("--color-black");
    };
}

function appearContainer() {
    return gsap.fromTo(container, {y: "100%"}, {y: 0, duration: 0.3});
}

function disappearContainer() {
    return gsap.fromTo(container, {y: 0}, {y: "-100%", duration: 0.3});
}

function appearLogo() {
    return gsap.fromTo(logo, {y: "100%", opacity: 0}, {y: 0, opacity: 1, duration: 0.3});
}

function disappearLogo() {
    return gsap.fromTo(logo, {y: 0, opacity: 1}, {y: "-100%", opacity: 0, duration: 0.3});
}

function start(timelineOptions) {
    init();

    if (container && logo) {
        const timeline = gsap.timeline(timelineOptions)
            .add(reset())
            .add(appearLogo(), ">")
        ;

        // animate background
        const properties = [
            "--color-palette-1",
            "--color-palette-2",
            "--color-palette-3",
            "--color-palette-4",
            "--color-black",
        ];

        properties.forEach((property) => {
            timeline.to(
                container,
                {
                    backgroundColor: bodyStyle.getPropertyValue(property),
                    duration: 0.2,
                    ease: "power1.inOut",
                },
                "+=0.2"
            );
        });

        timeline
            .add(disappearLogo(), ">")
            .add(disappearContainer(), ">")
        ;
    }
}

function hide() {
    init();

    if (container) {
        container.style.display = "none";
    }
}

export function pageLeave(timelineOptions) {
    init();

    if (container && logo) {
        return gsap.timeline(timelineOptions)
            .add(reset())
            .add(setBlackBackground())
            .add(appearContainer())
            .add(appearLogo());
    }
}

export function pageEnter(timelineOptions) {
    init();

    if (container && logo) {
        return gsap.timeline(timelineOptions)
            .add(disappearLogo())
            .add(disappearContainer());
    }
}

export default (callback) => {
    const lastVisit = parseInt(localStorage.getItem("lastVisit") || 0);
    const now = Math.round(Date.now() / 1000);

    if (lastVisit) {
        const expire = lastVisit + 86400;

        if (now < expire) {
            hide();

            if (typeof callback === "function") {
                callback();
            }

            return;
        }
    }

    localStorage.setItem("lastVisit", now.toString());

    start({onComplete: callback});
};
